import { BudgetOptimizationContext } from '@/dashboards/BudgetOptimization/context/BudgetOptimizationContext';
import { useContext } from 'use-context-selector';

export const useBudgetOptimizationContext = () => {
    const context = useContext(BudgetOptimizationContext);

    if (!context) {
        throw new Error(
            'useBudgetOptimizationContext must be used within a BudgetOptimizationContextProvider',
        );
    }

    return context;
};
